export class ContractNoticeInfo {
  // public 変数 ------------------------------------------------------------------------
  public planCode: string = null;    // プランコード
  public orderNo: number = 0;    // 表示順序
  public noticeMessage: string = null;    // 告知事項メッセージ
  // ------------------------------------------------------------------------
}
